import { render, staticRenderFns } from "./PlayCollapseItem.vue?vue&type=template&id=8bb2c544&scoped=true"
import script from "./PlayCollapseItem.vue?vue&type=script&lang=js"
export * from "./PlayCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./PlayCollapseItem.vue?vue&type=style&index=0&id=8bb2c544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2c544",
  null
  
)

export default component.exports